import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $initialCurrenciesAvailableStore } from '@lib/store';
import { cn } from '@shared/utils';
import type { IntegrationType } from '@shared/api';
import { Select, Text } from '@shared/widgets';
import xeroImg from '@assets/icons/integrations/xero-logo.svg?url';

interface IntegrationTitleProps {
  className?: string;
  name: IntegrationType;
  currency?: string;
  onChangeCurrency: (currency: string | undefined) => void;
}

export const IntegrationTitle = (props: IntegrationTitleProps) => {
  const currenciesAvailableStore = useUnit($initialCurrenciesAvailableStore.store);

  const { t } = useTranslation('integration');

  return (
    <div className={cn('flex flex-wrap items-center justify-between gap-2', props.className)}>
      <div className='flex items-center gap-4'>
        <img className='h-10 w-10' src={xeroImg} alt='Xero' />
        <Text size='2xl'>{t('header.title', { name: props.name })}</Text>
      </div>
      <Select
        className='min-w-[160px]'
        items={currenciesAvailableStore.data}
        nullValue={{ isEnable: true, text: t('placeholders.allCurrencies', { ns: 'common' }) }}
        value={props.currency}
        onChange={props.onChangeCurrency}
      />
    </div>
  );
};
